const defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/

const formmasks = {
  money: ["#,##", "##,##", "###,##", "####,##", "#####,##", "######,##"],
  cpf: "###.###.###-##",
  cnpj: "##.###.###/####-##",
  number: "####################",
  countrycode: ['+##'],
  ddd: ['(##)'],
  cpfcnpj: ['###.###.###-##', '##.###.###/####-##'],
  phoneWithDDD: ['(##) ####-####', '(##) #####-####'],
  telefone: ['####-####', '#####-####'],
  celular: ['#####-####'],
  cep: ['#####-###'],
  date: ['##/##/####'],
  unmask: text => {
    return text ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '') : text
  }
}

export {
  formmasks
}
